import {HOSTONBOARDING, space} from "../../../api/apiPaths";
import {get} from "../../../api/commonAPI";
import * as actionType from "./NewHostOnboardingActionType";

export const getHostOnboardingData = (page, size, country, searchName) => {
    return dispatch => {
        dispatch({
            type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA
        });
        let url = `${HOSTONBOARDING}/filter?page=${page}&size=${size}&q=${searchName ? searchName : ''}`
        if(country) url = `${url}&country=${country}`;
        get(url)
            .then(res => {
                dispatch({
                    type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA_FAILS,
                    payload: error
                });
            });
    };
};

export const fetchHostOnboardingDataById =  (id, setFetchedData) => {
    return  dispatch => {
        dispatch({
            type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID
        });
        let url = `${HOSTONBOARDING}/${id}`;
        get(url)
            .then(res => {
                dispatch({
                    type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_SUCCESS,
                    payload: res.data
                });
                setFetchedData(true)
            })
            .catch(error => {
                dispatch({
                    type: actionType.FETCH_NEW_HOST_ONBOARDING_DATA_BY_ID_FAILS,
                    payload: error
                });
            });

    };
};

export const getCountryCode = (token) =>{
    return  dispatch => {
        dispatch({
            type: actionType.COUNTRY_CODE_SUBMIT
        });
        get(`api/ui/country`)
            .then(res => {
                dispatch({
                    type: actionType.COUNTRY_CODE_SUBMIT_SUCCESS,
                    payload: res.data
                });
            })
            .catch(error => {
                dispatch({
                    type: actionType.COUNTRY_CODE_SUBMIT_ERROR,
                    payload: error
                });
            })
    };
};